<template>
  <footer class="bg-card border-solid border-t-2 mt-8">
    <div class="container">
      <div class=" flex items-center h-16 text-xs bg-card ">
        {{ new Date().getFullYear() }} winwintech
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'app-footer'
}
</script>

<style scoped>

</style>
